export default "__VITE_ASSET__B2Sh1ap0__"